import React from "react";
import { Delete, Edit, PlayCircleOutlined, Settings } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Popover, Radio, RadioGroup, Stack, TextField, Tooltip, Typography } from "@mui/material";
import Service from "../../../util/Service";
import BpmnManagerDialog from "../../bpm/manager/BpmnManagerDialog";


export default function EditarPortalSetting(props) {
    const { pagina, placement } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [openDialogCode, setOpenDialogCode] = React.useState(false);
    const [openBpm, setOpenBpm] = React.useState(false);
    const [value, setValue] = React.useState('BPMn');
    const [api, setApi] = React.useState('');
    const [bpm, setBpm] = React.useState(pagina.nome);
    const [dadoController, setDadoController] = React.useState('');

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleClickOpenCode = () => {
        setOpenDialogCode(true);
    };

    const handleCloseDialogCode = () => {
        setOpenDialogCode(false);
    };
    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleCriarDinamico() {
        const dado = {
            idPagina: pagina.id
        }
        if (value === "API") {
            dado.api = api;
        } else {
            dado.bpm = bpm;
        }
        console.log(dado);
        
        Service.POST("/api/security/paginaHtml/settingDynamic", dado).then(r => {
            console.log(r);
            if (r.success) {
                handleClose();
                handleCloseDialog();
            } else {
                alert(r.msg)
            }
        }).catch(er => alert(er))
    }
    function handleCallController() {
        console.log('>>>handleCallController<<<', pagina.controller);
        Service.GET("/api/security/paginaDinamica/callController/" + pagina.controller).then(r => {
            console.log(r);
            setDadoController(r);
            handleClickOpenCode();
        }).catch(er => alert(er))
    }
    function handleAbrirBPM(){
        console.log( pagina);
        setOpenBpm( true );
    }
    function montaController() {
        if (!pagina.controller) return;
        let tipo = 'BPMn'
        const controller = pagina.controller;
        if (controller.indexOf("/") === 0) {
            tipo = 'API'
        }
        return (
            <React.Fragment>
                <ListItem
                    alignItems="flex-start"
                    secondaryAction={
                        <IconButton edge="end" aria-label="dinamico" color="primary" onClick={handleAbrirBPM}>
                            <Edit />
                        </IconButton>
                    }
                >
                    <ListItemText
                        primary={tipo}
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                >
                                    {controller}
                                </Typography>
                            </React.Fragment>
                        }
                    />
                </ListItem>
                <ListItem
                    alignItems="flex-start"
                >
                    <ListItemButton size="small" onClick={handleCallController}>
                        Executar dado dinamico
                    </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem
                    alignItems="flex-start"
                >
                    <ListItemButton>
                        <ListItemText primary="Remover dinamicidade...." />
                        <ListItemIcon>
                            <Delete />
                        </ListItemIcon>

                    </ListItemButton>
                </ListItem>

            </React.Fragment>
        )
    }
    function montaGerarDinamico() {
        if (pagina.controller) return;
        return (
            <ListItem
                alignItems="flex-start"
                secondaryAction={
                    <IconButton edge="end" aria-label="dinamico" color="primary" onClick={handleClickOpen}>
                        <PlayCircleOutlined />
                    </IconButton>
                }
            >
                <ListItemText
                    primary="Pagina Estatica"
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: 'text.primary', display: 'inline' }}
                            >
                                Gostaria de defina-la como dinamica?
                            </Typography>
                        </React.Fragment>
                    }
                />
            </ListItem>
        )
    }

    return (
        <React.Fragment>
            <Tooltip title="Configurações avançada" placement={placement}>
                <IconButton
                    size="large"
                    color="inherit"
                    onClick={handleClick}
                >
                    <Settings />
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                    dense
                >
                    {montaGerarDinamico()}
                    {montaController()}
                </List>
            </Popover>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Definição de conteudo dinamico"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Toda pagina dinamica pecisa executar processo do lado do servidor para gerar seu conteudo.<br />
                        Pode ser indicado uma API ou um processo BPMn para gerar esse conteudo.
                    </DialogContentText>
                    <Paper>
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{
                                mt: 2,
                                p: 1
                            }}>
                            <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">Tipo de execução</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="female"
                                    name="radio-buttons-group"
                                    value={value}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="API" control={<Radio />} label="API" />
                                    <FormControlLabel value="BPMn" control={<Radio />} label="BPMn" />
                                </RadioGroup>
                            </FormControl>
                            {value === 'API' && <div style={{ alignSelf: 'center', justifyContent: 'center' }}>
                                <TextField label="Caminho da API" variant="outlined" value={api} onChange={e => setApi(e.target.value)} />
                            </div>}
                            {value === 'BPMn' &&
                                <div style={{ alignSelf: 'center', justifyContent: 'center' }}>
                                    <TextField label="Nome do processo BPMn" variant="outlined" value={bpm} onChange={e => setBpm(e.target.value)}

                                    />
                                </div>}

                        </Stack>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} autoFocus>
                        Cancelar
                    </Button>
                    <Button onClick={handleCriarDinamico} autoFocus>
                        Gerar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDialogCode}
                onClose={handleCloseDialogCode}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Paper>
                        <code>
                            {JSON.stringify(dadoController)}
                        </code>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogCode} autoFocus>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
            {pagina && pagina.controller && <BpmnManagerDialog open={openBpm} setOpen={setOpenBpm} bpm={pagina.controller} />}
        </React.Fragment>
    );
}